import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatareweofferingComponent } from './whatareweoffering.component';

const routes: Routes = [
  {path: '',
    component: WhatareweofferingComponent,
    data: { refreshComponent: true }}
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatareweofferingRoutingModule { }
